import { render, staticRenderFns } from "./truncated-value.vue?vue&type=template&id=17d03656&scoped=true&"
import script from "./truncated-value.vue?vue&type=script&lang=js&"
export * from "./truncated-value.vue?vue&type=script&lang=js&"
import style0 from "./truncated-value.vue?vue&type=style&index=0&id=17d03656&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d03656",
  null
  
)

export default component.exports